import React, {Component} from 'react';

export default class Cta extends Component {

  render() {
    return <div className={ (this.props.centered ? "cta-container " : "") }>
        <button className={ (this.props.light ? "cta-light " : "cta ") + this.props.className } onClick={this.props.click}>
            {this.props.lightIcon && <img className="light" alt="" src="/static/imgs/arrow-light.svg" />}
            {this.props.darkIcon && <img className="dark" alt="" src="/static/imgs/angle-right.svg" />}
            {this.props.simIcon && <img className="sim" alt="" src="/static/imgs/reload.svg" />}
            {this.props.downloadIcon && <img className="download" alt="" src="/static/imgs/download.png" />}
            {this.props.toolIcon && <img className="tool" alt="" src="/static/imgs/arrow-right-red.svg" />}
            {this.props.saveIcon && <img className="save" alt="" src="/static/imgs/save.svg" />}
            {this.props.plusIcon && <i className="fas fa-plus"></i>}
            <span>{this.props.text}</span>
        </button>
    </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/base/cta.js